var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgLogoAppStore = function SvgLogoAppStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "4 0 48 48",
    width: 48,
    height: 48
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0091ea",
    d: "M14.1 42h19.8a8.1 8.1 0 008.1-8.1V27H6v6.9a8.1 8.1 0 008.1 8.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b0ff",
    d: "M6 16h36v11H6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#40c4ff",
    d: "M33.9 6H14.1A8.1 8.1 0 006 14.1V16h36v-1.9A8.1 8.1 0 0033.9 6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.854 18.943l1.738-2.967-1.598-2.727a1.5 1.5 0 00-2.588 1.516l2.448 4.178z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.786 12.714a1.498 1.498 0 00-2.052.536L16.09 28h3.477l7.754-13.233a1.5 1.5 0 00-.535-2.053z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.521 32.92L26.91 19.933l-.763 1.303a4.115 4.115 0 00-.185 3.011l5.972 10.191a1.498 1.498 0 002.052.535 1.5 1.5 0 00.535-2.053z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.473 27.919l-.171-.289a4.01 4.01 0 00-.498-.621H12.3c-.829 0-1.5.665-1.5 1.484s.671 1.484 1.5 1.484h13.394a2.696 2.696 0 00-.221-2.058z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.66 32.961a2.78 2.78 0 00-2.03-.959h-.004a4.132 4.132 0 00-.932.087l-.487.831a1.5 1.5 0 002.588 1.518l.865-1.477z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30.196 27.009H35.7c.829 0 1.5.665 1.5 1.484s-.671 1.484-1.5 1.484h-5.394c-.194-.653-.296-2.781-.11-2.968z"
  })));
};
export default SvgLogoAppStore;